module.exports = "https://wrf-static.prod-my.games/promo/long-lp/img/apple.9c15b1fa.svg";